<template>
  <!-- 头部整体盒子 -->
  <div>
    <!-- 占位 -->
    <div class="header-box" v-if="$route.path != '/home'"></div>
    <div
      id="header"
      class="container-fuild"
      :style="navStyle"
      :class="{ 'm-nav': showMnav == true }"
    >
      <div class="container">
        <!-- 电脑导航 -->
        <div
          class="header-nav hidden-xs hidden-sm"
          :class="{ scrollNav: $route.path == '/home' && percent !== 1 }"
        >
          <!-- 导航logo -->
          <div class="header-nav-logo">
            <!-- <div class="header-nav-logo-icon f-64 m-r-18">
              <svg-icon iconClass="logo" className="logo"></svg-icon>
            </div> -->
            <div class="header-nav-logo-icon m-r-18">
              <img
                v-if="headerInfo.logo && headerInfo.logo.length"
                style="width:100%;height:100%"
                :src="headerInfo.logo[0].url"
              />
            </div>

            <div>
              <div class="header-nav-logo-text f-16 m-b-11">
                {{ headerInfo.siteName }}
              </div>
              <div
                class="flex-sb p-tb-2 p-l-18 p-rp5 header-nav-logo-desc f-10"
              >
                <div>世间珍馐</div>
                <div class="text-right">
                  人间美味
                </div>
              </div>
            </div>
          </div>
          <!-- 导航内容 -->
          <ul class="header-nav-wrapper">
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="navIndex == index ? 'active' : ''"
              @click="navClick(index, item.name, item)"
            >
              <router-link :to="jumpToPage(item)">
                {{ item.name }}
                <span
                  v-if="item.children.length > 0"
                  class="glyphicon glyphicon-menu-down"
                ></span>
                <i class="underline"></i>
              </router-link>
              <dl
                v-if="item.children.length > 0"
                style="background: rgba(0, 0, 0, 0.6);"
              >
                <dt v-for="(i, n) in item.children" :key="n">
                  <router-link :to="toDetail(i, n)">
                    <div style="display: flex; align-items: center;">
                      <div class="m-r-14 img">
                        <img
                          v-if="i.img && i.img.length > 0"
                          style="width: 100%; height: 100%;"
                          :src="imgPrefix + i.img[0].url"
                        />
                        <template v-else>
                          <img
                            v-if="item.name == '品牌故事'"
                            style="width: 100%; height: 100%;"
                            src="@/assets/img/brandLogo.png"
                          />
                          <img
                            v-if="item.name == '基地介绍'"
                            style="width: 100%; height: 100%;"
                            src="@/assets/img/consLogo.png"
                          />
                        </template>
                      </div>

                      <div style="flex: 1;">
                        <div class="ellipsis-2" style="line-height: 1.3;">
                          {{ i.name }}
                        </div>
                      </div>
                    </div>
                  </router-link>
                </dt>
              </dl>
            </li>
            <!-- 用户头像 -->
            <!-- <li class="dropdown">
              <div
                class="dropdown-toggle"
                id="dropdownMenu1"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
                style="display: flex; align-items: center;"
              >
                <img
                  style="width: 40px; height: 40px; border-radius: 50%;"
                  src="@/assets/img/logo_hp.png"
                />

                <div>张主管</div>
                <div>管理员</div>
                <span class="caret"></span>
              </div>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                <li><a href="#">退出登录</a></li>
              </ul>
            </li> -->
          </ul>
        </div>
        <!-- 手机导航 -->
        <div class="header-nav-m container-fuild visible-xs visible-sm">
          <div style="display: flex; align-items: center;">
            <!-- <div class="header-nav-m-logo f-32">
              <svg-icon iconClass="logo" className="logo"></svg-icon>
            </div> -->
            <div class="header-nav-m-logo">
              <img
                v-if="headerInfo.logo && headerInfo.logo.length"
                :src="headerInfo.logo[0].url"
              />
            </div>
            <div class="header-nav-m-title m-l-10">
              {{ headerInfo.siteName }}
            </div>
          </div>
          <div class="f-16 list-btn">
            <svg-icon
              @click="menuClick"
              v-if="!showMnav"
              :iconClass="listClass"
              className="list"
            ></svg-icon>
            <svg-icon
              v-if="showMnav"
              iconClass="close"
              @click="closeMenu"
            ></svg-icon>
          </div>
        </div>
      </div>
    </div>
    <Mobile-Nav v-model="showMnav" :navList="navList" />
  </div>
</template>
<script>
import MobileNav from "@/components/MobileNav/index";
export default {
  props: {
    // 导航栏背景颜色透明度
    percent: {
      type: [String, Number]
    },
    navStyle: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  provide() {
    return {
      args: { pageSize: this.pageSize, total: this.total }
    };
  },
  components: {
    MobileNav
  },
  name: "Header",
  data() {
    return {
      // navIndex: sessionStorage.getItem('navIndex')
      //   ? sessionStorage.getItem('navIndex')
      //   : 0,
      // navIndex: this.$store.state.navIndex,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      showMnav: false,
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },

        {
          name: "新闻政策",
          path: "/news-policy",
          children: []
        },
        {
          name: "市场行情",
          path: "/market",
          children: []
        },
        {
          name: "当季热销",
          path: "/home",
          children: []
        },
        {
          name: "野生菌百科",
          path: "/baike",
          children: []
        },
        {
          name: "品牌故事",
          children: []
        },

        {
          name: "基地介绍",
          children: []
        }
      ],
      companyList: [],
      baseList: [],
      imgPrefix: process.env.VUE_APP_BASE_URL,
      pageSize: 5,
      total: 0,
      headerInfo: {}
    };
  },
  computed: {
    listClass() {
      let icon = "list1";
      if (this.$route.path == "/home" && this.percent !== 1) {
        icon = "list";
      }
      return icon;
    },
    navIndex() {
      return this.$store.getters.GetNavIndex;
    }
  },
  created() {
    this.getCompanyList();
    this.getMushroomBaseList();
    this.getData();
  },
  methods: {
    navClick(index, name, item) {
      // sessionStorage.setItem('navIndex', index)
      localStorage.setItem("navIndex", index);
      this.$store.commit("SetNavIndex", index);
      this.menuName = name;
    },
    menuClick() {
      this.showMnav = true;
    },
    closeMenu() {
      this.showMnav = false;
    },
    // 获取企业列表
    async getCompanyList() {
      let res = await this.$api.common.getCompanySelectInfo();
      try {
        if (res.code == 200) {
          this.companyList = res.data.map(item => {
            let obj = {
              name: item.enterpriseName,
              id: item.id,
              pathName: "Brand"
            };
            // if (item.corporate_logo) {
            //   obj["img"] = JSON.parse(item.corporate_logo);
            // }

            return obj;
          });
          this.navList.forEach(item => {
            if (item.name == "品牌故事") {
              item.children = this.companyList;
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 获取基地列表
    async getMushroomBaseList() {
      let ob = {
        pageNo: 1,
        pageSize: this.pageSize
      };
      let res = await this.$api.home.getMushroomBaseSimpleList(ob);
      try {
        if (res.code == 200) {
          this.total = res.data.total;
          this.baseList = res.data.records.map(item => {
            let obj = {
              name: item.base_name,
              id: item.id,
              pathName: "construction"
            };
            if (item.base_picture_url) {
              obj["img"] = JSON.parse(item.base_picture_url);
            }

            return obj;
          });
          this.navList.forEach(item => {
            if (item.name == "基地介绍") {
              item.children = this.baseList;
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    //获取logo信息
    async getData() {
      let res = await this.$api.common.getFooterBasicInfo();
      try {
        if (res.code == 200) {
          if (res.data) {
            for (let key in res.data) {
              if (
                key == "theRelevantUnits" ||
                key == "officialWechat" ||
                key == "logo"
              ) {
                if (res.data[key]) {
                  let arr = JSON.parse(res.data[key]).map(item => {
                    item.url = this.imgPrefix + item.url;
                    return item;
                  });
                  this.$set(this.headerInfo, key, arr);
                }
                continue;
              }
              this.$set(this.headerInfo, key, res.data[key]);
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    toDetail(item, index) {
      let args = {
        id: item.id,
        query: {
          index: index,
          page: 1,
          pageSize: this.pageSize,
          total: this.total
        }
      };
      return { name: item.pathName, params: { args: JSON.stringify(args) } };
    },
    // 导航跳转
    jumpToPage(item) {
      if (item.path) {
        if (item.path == "/home") {
          return { path: item.path, query: { type: item.name } };
        }
        return item.path;
      }
      return "";
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/style/mixin.scss";
/* 顶部 */
#header {
  background: #fff;
  transition: background 0.3s linear;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
}
.header-box {
  height: 90px;
}
.m-nav {
  background: #fff !important;
  color: #000 !important;
}

/* 导航栏 */
#header .header-nav {
  /* height: 50px; */
  width: 100%;
  height: 90px;
  // line-height: 90px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  /* width: 100px; */
  height: 100%;
  float: left;
  display: flex;
  align-items: center;
  &-text {
    // color: rgba(0, 0, 0, 1);
    letter-spacing: 1px;
  }
  &-desc {
    color: rgba(255, 255, 255, 1);
    background: rgba(29, 112, 69, 1);
    border-radius: 36px;
    letter-spacing: 13px;
  }
  &-icon {
    width: 64px;
    height: 64px;
  }
}
/* 导航栏 导航容器 */
#header .header-nav .header-nav-wrapper {
  float: right;
  margin: 0;

  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  // margin: 0 15px;
  position: relative;
  height: 90px;
}
#header .header-nav .header-nav-wrapper .dropdown {
  display: flex;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  position: relative;
  width: 96px;
  height: 90px;
  line-height: 90px;
  text-align: center;
  display: block;
}
/*导航栏滑动a链接样式*/
#header .scrollNav .header-nav-wrapper > li > a {
  color: #fff;
}
// /* 导航栏 每个导航下面的 a 链接的下划线 */
// #header .header-nav .header-nav-wrapper > li > a > i {
//   display: block;
//   position: absolute;
//   bottom: -2px;
//   left: 50%;
//   width: 0;
//   height: 2px;
//   opacity: 0;
//   transition: all 0.6s ease;
//   background-color: #1e73be;
// }
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  // color: #1e73be;
  text-decoration: none;
  background: #1d7045;
  color: white;
}
// /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
// #header .header-nav .header-nav-wrapper > li > a:hover .underline {
//   opacity: 1;
//   width: 100%;
//   left: 0;
// }
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  text-decoration: none;
  color: white;
  background-color: #1d7045;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 250px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
  &::-webkit-scrollbar {
    width: 8px;
    background: rgba(255, 255, 255, 0.4);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.7);
    border-radius: 5px;
  }
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 15px 15px 0;
  margin-bottom: 15px;
  // border-bottom: 1px solid #ccc;
}
#header .header-nav .header-nav-wrapper > li > dl > dt .img {
  width: 63px;
  height: 63px;
  border-radius: 10px;
}
#header .header-nav .header-nav-wrapper > li > dl > dt a {
  color: white;
}
#header .header-nav .header-nav-wrapper > li > dl > dt .ellipsis-2 {
  @include showEllipsis(2);
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt:hover > a {
  text-decoration: none;
  color: #000;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  height: 400px;
  overflow: auto;
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: white;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 占位容器 */
  .header-box {
    height: 45px;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 45px;
    line-height: 45px;
    width: 45px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    // width: 95px;
    // height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 32px;
    height: 32px;
  }
  /* 导航栏右侧菜单按钮*/
  #header .header-nav-m .list-btn {
    position: absolute;
    top: 0;
    bottom: 0;
    line-height: 45px;
    right: 0;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    // height: 50px;
    font-size: 20px;
    // line-height: 50px;
    // background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue